import {
    LandingNav,
    HeroSection,
    StackOverview,
    FeaturesGrid,
    CTASection,
    LandingFooter
  } from '../shared/components/landing';
  
  export function LandingPage() {
    return (
      <div className="min-h-screen bg-white">
        <LandingNav />
        <HeroSection />
        <StackOverview />
        <FeaturesGrid />
        <CTASection />
        <LandingFooter />
      </div>
    );
  }
  
  export default LandingPage;